//#region src/maitred_activity_type.ts
var MaitredActivityType = /* @__PURE__ */ function(MaitredActivityType) {
	MaitredActivityType[MaitredActivityType["Create"] = 1] = "Create";
	MaitredActivityType[MaitredActivityType["Update"] = 2] = "Update";
	MaitredActivityType[MaitredActivityType["Delete"] = 3] = "Delete";
	MaitredActivityType[MaitredActivityType["Add"] = 4] = "Add";
	MaitredActivityType[MaitredActivityType["Remove"] = 5] = "Remove";
	MaitredActivityType[MaitredActivityType["Move"] = 6] = "Move";
	MaitredActivityType[MaitredActivityType["LoggedIn"] = 7] = "LoggedIn";
	/** Used when we create a snapshot of a location without any other activity */
	MaitredActivityType[MaitredActivityType["LocationBackup"] = 8] = "LocationBackup";
	/** Used when we restore a snapshot of a location */
	MaitredActivityType[MaitredActivityType["LocationRestore"] = 9] = "LocationRestore";
	/**
	* Used when an action performs a snapshot across multiple locations.
	* Provides a reference point where we can restore all of those locations instead of having to
	* restore them one-by-one.
	*/
	MaitredActivityType[MaitredActivityType["Checkpoint"] = 10] = "Checkpoint";
	/** Used when we revert to a checkpoint. */
	MaitredActivityType[MaitredActivityType["CheckpointRevert"] = 11] = "CheckpointRevert";
	MaitredActivityType[MaitredActivityType["FrontEndBuildRelease"] = 12] = "FrontEndBuildRelease";
	MaitredActivityType[MaitredActivityType["ConfigurationAudit"] = 13] = "ConfigurationAudit";
	return MaitredActivityType;
}(MaitredActivityType || {});
//#endregion
export { MaitredActivityType };

//# sourceMappingURL=maitred_activity_type.js.map